import type {
  DeviceViewEntity,
  DeviceViewEntityId,
  DeviceViewWindows,
} from '../../deviceViewTypes';

// When tab is closed, get new active entity ID
export const getNewActiveEntityId = (
  deviceViewEntities: DeviceViewEntity[],
  deviceViewWindows: DeviceViewWindows,
): DeviceViewEntityId => {
  const foundDeviceViewEntity = deviceViewEntities.find(
    (entity) => !deviceViewWindows.some((win) => win.id === entity.id),
  );
  if (foundDeviceViewEntity === undefined) {
    if (deviceViewWindows.length) {
      return deviceViewWindows[0]!.id;
    }
    throw new Error('Device view entity not found');
  }
  return foundDeviceViewEntity.id;
};
